import gql from 'graphql-tag';

export const EDIT_TAG = gql`
  mutation editTag($tagId: Int!, $value: String!) {
    tagMutation {
      editTag(value: $value, tagId: $tagId)
    }
  }
`;
